import React from "react";
import Hero from "../components/Hero";
import classes from "./Home.module.css";
import { useNavigate } from "react-router-dom";
import useShopStore from "../store/useShopStore";
import ProductCard from "../components/ProductCard";
import { useEffect } from "react";
// import ProductsContainer from "../utils/ProductsContainer";
import GridCardContainer from "../utils/GridCardContainer";
import Spinner from "../utils/Spinner";
export default function Home() {
  const navigate = useNavigate();
  const { getProducts, products } = useShopStore((state) => state);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  return (
    <div>
      <Hero />

      <h2 className={classes.sectionHeading}>World of Drinks</h2>

      <div className={classes.categorieContainer}>
        <div onClick={() => navigate("/beer")} className={classes.categoryBox}>
          <h3 className={classes.headingCategory}>Beer</h3>

          <img
            className={classes.image}
            src="https://res.cloudinary.com/navi003/image/upload/v1674244657/Products/Bierkato_i7xocj.jpg"
            alt="Beer"
          />
        </div>
        <div
          onClick={() => navigate("/spirits")}
          className={classes.categoryBox}
        >
          <h3 className={classes.headingCategory}>Spirits</h3>

          <img
            className={classes.image}
            src="https://res.cloudinary.com/navi003/image/upload/v1674244820/Products/Spiritiousen_krlhs7.jpg"
            alt="beer"
          />
        </div>
        <div onClick={() => navigate("/wine")} className={classes.categoryBox}>
          <h3 className={classes.headingCategory}>Wine and Sekt</h3>

          <img
            className={classes.image}
            src="https://res.cloudinary.com/navi003/image/upload/v1674244890/Products/Sekt_q7nkee.jpg"
            alt="beer"
          />
        </div>
      </div>

      <h2 className={classes.sectionHeading}>All Products</h2>
      <GridCardContainer style={{ marginBottom: "20rem" }}>
        {products ? (
          products.map((product) => {
            return (
              <ProductCard
                image={product.image}
                title={product.name}
                category={product.category}
                price={product.price}
                key={product._id}
                id={product._id}
              />
            );
          })
        ) : (
          <Spinner />
        )}
      </GridCardContainer>
    </div>
  );
}
